module.exports = __webpack_public_path__ + "img/a0bef4e.jpg";